import { maxDisplayWidth, unitPrecision, designWidth } from "@/config";
import { Toast } from "antd-mobile";
import qs from "qs";
export const pxChangeVw = (px: string | number | undefined, isNumber = false): string | number => {
  px = parseFloat(px as string);
  const innerWidth = window.innerWidth;
  if (innerWidth >= maxDisplayWidth) {
    return Math.round(((px * maxDisplayWidth) / designWidth) * 10 ** unitPrecision) / 10 ** unitPrecision + "px";
  }
  const value = Math.round(((px * 100) / designWidth) * 10 ** unitPrecision) / 10 ** unitPrecision;
  return isNumber ? value : value + "vw";
};
export const pxToVw = (px: string | number | undefined) => {
  px = parseFloat(px as string);
  const innerWidth = window.innerWidth;
  if (innerWidth >= maxDisplayWidth) return ((px * maxDisplayWidth) / designWidth).toFixed(unitPrecision) + "px";
  return ((px / designWidth) * 100).toFixed(unitPrecision) + "vw";
};
export const pxToVh = (px: string | number) => {
  px = parseFloat(px as string);
  return ((px / 812) * 100).toFixed(unitPrecision) + "vh";
};

export const debounce = (fn: Function, delay: number = 300) => {
  let timer: any = null;
  return function (...args: any[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(fn.bind(null, ...args), delay);
  };
};

export function getUrlParamsWithoutHash(url: string | URL) {
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  return {
    protocol: urlObj.protocol,
    host: urlObj.host,
    pathname: urlObj.pathname,
    search: urlObj.search,
    params: Object.fromEntries(params.entries()),
  };
}

export function parseURL(url: string) {
  const parser = document.createElement("a");
  parser.href = url;
  const parsedURL = {
    protocol: parser.protocol,
    hostname: parser.hostname,
    port: parser.port,
    path: parser.pathname,
    query: parser.search,
    hash: parser.hash,
  };
  return parsedURL;
}

export function getParams(strlen: any, str: string | number) {
  let c = strlen;
  if (c.includes("?")) {
    c = c.split("?")[1];
  }
  const obj = qs.parse(c) || {};
  return obj[str] || "";
}

export function formatFileSize(size: number, pointLength = 2) {
  if (size < 1024) {
    return size + "B";
  } else if (size < 1024 * 1024) {
    return (size / 1024).toFixed(pointLength) + "KB";
  } else {
    return (size / 1024 / 1024).toFixed(pointLength) + "MB";
  }
}

// export const getHashSearchParam: any = (key: string) => {
//   const search = /(?<=#.*\?).*/.exec(window.location.href)?.[0];
//   const usp = new URLSearchParams(search);
//   return usp.get(key);
// };
// export const getSearchParam: any = (key: string) => {
//   const string = new URLSearchParams(window.location.search).get(key);
//   if (!!string) {
//     return string;
//   }
//   return getHashSearchParam(key);
// };

export function getSearchParam(key: string) {
  const url = new URL(window.location.href);
  const search = url.search;
  const hash = url.hash;
  const hashSearch = hash.split("?")[1];
  let combinedSearch = search;
  if (hashSearch) {
    combinedSearch += (search ? "&" : "?") + hashSearch;
  }
  const usp = new URLSearchParams(combinedSearch);
  return usp.get(key);
}

export function getParamType(paramKey: string = "_t", url: string | URL = window.location.href) {
  const urlObj = new URL(url);
  const searchParams = new URLSearchParams(urlObj.search.substring(1));
  const index = urlObj.hash.indexOf("?");
  const hashParams = new URLSearchParams(urlObj.hash.substring(index + 1));
  if (searchParams.has(paramKey)) {
    return "search";
  } else if (hashParams.has(paramKey)) {
    return "hash";
  }
  return "not found";
}
export function setSearchParams(paramKey: string = "_t", paramValue: any = Date.now()) {
  const url = new URL(location.href);
  url.searchParams.set(paramKey, paramValue);
  window.history.replaceState({}, "", url.toString());
}

export function setHashParams(params: any = { _t: Date.now() }) {
  // 去除当前的哈希值
  var currentHash = window.location.hash.substr(1);
  var currentHashWithoutParams = currentHash.split("?")[0];
  // 将新的查询参数添加到当前的哈希值中
  var newHash = currentHashWithoutParams + "?" + new URLSearchParams(params).toString();
  // 设置新的哈希值
  window.location.hash = newHash;
}

export function getRandomElement(arr: string | any[] = [1, 2, 3, 4, 5, 6, 7, 8]) {
  var index = Math.floor(Math.random() * arr.length);
  return arr[index];
}

export function buildUrl(url: string, params: any) {
  let queryString = "";
  for (const key in params) {
    if (params.hasOwnProperty(key) && !isEmptyType(params[key])) {
      queryString += encodeURIComponent(key) + "=" + encodeURIComponent(params[key]) + "&";
    }
  }
  queryString = queryString.slice(0, -1);
  return url + "?" + queryString;
}

export const copyText = (text: string) => {
  return new Promise((resolve, reject) => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          Toast.show({
            position: "top",
            duration: 1000,
            content: "复制成功",
            maskClickable: false,
          });
          resolve(true);
        })
        .catch(err => {
          Toast.show({
            position: "top",
            duration: 1000,
            content: "复制失败",
            maskClickable: false,
          });
          reject(err);
        });
    } else {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", text);
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, 9999);
      if (document.execCommand("copy")) {
        resolve(true);
      } else {
        reject(false);
      }
      document.body.removeChild(input);
    }
  });
};

export async function getImageSize(img: { naturalWidth: number; naturalHeight: number; src: any }) {
  if (img.naturalWidth) {
    return {
      width: img.naturalWidth,
      height: img.naturalHeight,
      ratio: img.naturalWidth / img.naturalHeight,
    };
  } else {
    return await getImageSizeByUrl(img.src);
  }
}
export function getImageSizeByUrl(url: string) {
  return new Promise(function (resolve, reject) {
    const image = new Image();
    image.onload = function () {
      resolve({
        width: image.naturalWidth,
        height: image.naturalHeight,
        ratio: image.naturalWidth / image.naturalHeight,
      });
    };
    image.onerror = function () {
      reject(new Error("error"));
    };
    image.src = url;
  });
}

export function filterEmptyValues(object: any) {
  return Object.keys(object).reduce((acc: any, key) => {
    if (!isEmptyType(object[key])) {
      acc[key] = object[key];
    }
    return acc;
  }, {});
}

export const getImg = (str: string) => {
  return new URL(`../assets/img/${str}`, import.meta.url).href;
};
export const getIcon = (str: any) => {
  return new URL(`../assets/icons/${str}`, import.meta.url).href;
};

export const getSvg = (str: any) => {
  return new URL(`../assets/icons/${str}`, import.meta.url).href;
};

export function isEmptyElement(element: { innerHTML: any }) {
  if (element) {
    return isEmptyType(element.innerHTML);
  } else {
    return true;
  }
}

export function hidden_advert(ins: any) {
  if (isEmptyType(ins)) {
    return;
  }
  if (isEmptyElement(ins) || !ins.hasAttribute("data-ad-status")) {
    ins.parentElement.style.display = "none";
  }
}

export function createDefaultObject(defaultValue: any, object_map: { [s: string]: unknown } | ArrayLike<unknown>) {
  const handler: any = {
    get: function (target: { [x: string]: any }, key: string) {
      return key in target ? target[key] : defaultValue;
    },
    set: function (target: { [x: string]: any }, key: string | number, value: any) {
      target[key] = value;
      return true;
    },
  };
  const proxyInstance = new Proxy({}, handler);
  for (const [key, value] of Object.entries(object_map)) {
    Reflect.set(proxyInstance, key, value);
  }
  return proxyInstance;
}

export function loadScript(url: string, callback: () => void) {
  try {
    const script: any = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.setAttribute("crossorigin", "anonymous");
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
      script.onerror = (event: any) => {
        console.log(event);
      };
    }
    script.src = url;
    document.head.appendChild(script);
  } catch (e) {
    console.error("Error loading script:", e);
  }
}

export function getFormattedDomain(url: string = window.location.href): string {
  try {
    const parsedUrl = new URL(url);
    const hostnameParts = parsedUrl.hostname.split(".");
    if (hostnameParts.length < 2) {
      throw new Error("Invalid hostname format");
    }
    const subdomainAndMainDomain = hostnameParts.slice(0, -1).join("-");
    return subdomainAndMainDomain.replace(/-/g, "_");
  } catch (error) {
    console.error("Error parsing URL:", error);
    return "";
  }
}

export function getWeatherDomainType() {
  const hostname = window.location.hostname.toLowerCase();
  if (hostname.endsWith("24hweather.com")) {
    return "24hweather.com";
  }
  return "comfortweather.com";
}

export function isTestLink(testUrls: string[]) {
  const { prefix } = usePrefix();
  return window.location.hostname === "test.comfortweather.com" && testUrls.includes(`${prefix}.comfortweather.com`);
}

export function isLocalLink() {
  return window.location.hostname === "localhost";
}
